import React, { useState } from 'react';
import { COLORS } from '../../../../utils/constants';
import { adminAPI } from '../../../../services/api';
import { useAdminToast } from '../../../../hooks/useAdminToast';
import { ModalWrapper } from './ModalComponents';

// Tag colors mapping
const tagColors = {
  VIP: '#f59e0b',
  Premium: '#8b5cf6',
  Новый: '#22c55e',
  Проблемный: '#ef4444',
  Потенциальный: '#3b82f6',
  Bonus: '#14b8a6',
};

const MassTagModal = ({ selectedClients, availableTags, onClose, onSuccess }) => {
  const { toast } = useAdminToast();
  const [selectedTag, setSelectedTag] = useState('');
  const [customTag, setCustomTag] = useState('');
  const [loading, setLoading] = useState(false);

  const handleSubmit = async () => {
    const tag = selectedTag || customTag.trim();
    if (!tag) return;
    
    setLoading(true);
    let successCount = 0;
    
    for (const clientId of selectedClients) {
      try {
        await adminAPI.addClientTag(clientId, tag);
        successCount++;
      } catch (err) {
        console.error(`Failed to add tag to ${clientId}`);
      }
    }
    
    toast.actionResult(successCount, selectedClients.length, `Тег "${tag}" добавлен`);
    onSuccess();
  };

  return (
    <ModalWrapper title="Массовое добавление тега" onClose={onClose}>
      <div style={{ padding: '16px', backgroundColor: COLORS.background, borderRadius: '8px', marginBottom: '16px' }}>
        <div style={{ color: COLORS.textSecondary, fontSize: '13px', marginBottom: '4px' }}>Выбрано клиентов</div>
        <div style={{ color: COLORS.primary, fontSize: '28px', fontWeight: '700' }}>{selectedClients.length}</div>
      </div>

      <div style={{ marginBottom: '16px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Выберите тег</label>
        <div style={{ display: 'flex', flexWrap: 'wrap', gap: '8px' }}>
          {availableTags.map(tag => (
            <button
              key={tag.name || tag}
              onClick={() => { setSelectedTag(tag.name || tag); setCustomTag(''); }}
              style={{
                padding: '8px 16px',
                borderRadius: '20px',
                backgroundColor: selectedTag === (tag.name || tag) ? `${tagColors[tag.name || tag] || '#6b7280'}30` : COLORS.background,
                border: `2px solid ${selectedTag === (tag.name || tag) ? tagColors[tag.name || tag] || '#6b7280' : COLORS.border}`,
                color: tagColors[tag.name || tag] || '#6b7280',
                fontSize: '13px',
                fontWeight: '600',
                cursor: 'pointer',
              }}
            >
              {tag.name || tag}
            </button>
          ))}
        </div>
      </div>

      <div style={{ marginBottom: '20px' }}>
        <label style={{ display: 'block', color: COLORS.textSecondary, fontSize: '13px', marginBottom: '6px' }}>Или введите свой</label>
        <input
          type="text"
          value={customTag}
          onChange={(e) => { setCustomTag(e.target.value); setSelectedTag(''); }}
          placeholder="Свой тег..."
          style={{
            width: '100%',
            padding: '12px',
            backgroundColor: COLORS.background,
            border: `1px solid ${COLORS.border}`,
            borderRadius: '8px',
            color: COLORS.text,
            fontSize: '14px',
            boxSizing: 'border-box',
          }}
        />
      </div>

      <button
        onClick={handleSubmit}
        disabled={loading || (!selectedTag && !customTag.trim())}
        style={{
          width: '100%',
          padding: '14px',
          backgroundColor: loading || (!selectedTag && !customTag.trim()) ? COLORS.border : COLORS.primary,
          border: 'none',
          borderRadius: '8px',
          color: '#000',
          fontSize: '15px',
          fontWeight: '600',
          cursor: loading || (!selectedTag && !customTag.trim()) ? 'not-allowed' : 'pointer',
        }}
      >
        {loading ? 'Добавление...' : `Добавить тег "${selectedTag || customTag || '...'}"`}
      </button>
    </ModalWrapper>
  );
};

export default MassTagModal;
